import { Subject } from 'rxjs';

const footerHeightSubject = new Subject();

export const TabsLayoutService = {
    changeFooterHeight: data => footerHeightSubject.next(data),
    getFooterHeight: () => footerHeightSubject.asObservable(),
};
